import { useTranslation } from "react-i18next";
import Spinner from "@/components/Spinner";
import { useContractorCardContext } from "../context";

export const ContractorCardLoading = () => {
  const { t } = useTranslation();
  const { loadingState } = useContractorCardContext();

  return (
    <div className="flex flex-col justify-center items-center h-64 space-y-4">
      <Spinner />
      <p className="text-sm text-muted-foreground">
        {t(`contractorCards.loadingStates.${loadingState.reason}`)}
      </p>
    </div>
  );
};
